var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:{
    badge: true,
    [`badge-request-status-${_vm.classStatus}`]: true
}},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }